const rules = {
  isRequired: {
    error: 'This field is required',
    validate: (value) => value && (typeof value === 'object' || value.length > 0),
  },
  noSpecialCharacters: {
    error: 'No special characters allowed',
    validate: (value) => !value || value.match(/^[\s0-9A-Za-z\u00E0-\u00FC]+$/),
  },
  validEmail: {
    error: 'Invalid email address',
    // eslint-disable-next-line max-len, no-useless-escape
    validate: (value) => !value || value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  },
  hasNumbers: {
    error: 'This field must contain at least one number',
    validate: (value) => !value || value.match(/[0-9]+/),
  },
  hasSpecialCharacters: {
    error: 'This field must contain at least one special character',
    validate: (value) => !value || !value.match(/^[0-9A-Za-z\u00E0-\u00FC]+$/),
  },
  hasUppercaseLetters: {
    error: 'This field must contain at least one uppercase letter',
    validate: (value) => !value || value.match(/[A-Z]+/),
  },
  minLength: (minLength) => ({
    error: `The minimum length of this field is ${minLength} character(s)`,
    validate: (value) => !value || value.length >= minLength,
  }),
  maxLength: (maxLength) => ({
    error: `The maximum length of this field is ${maxLength} character(s)`,
    validate: (value) => !value || value.length <= maxLength,
  }),
  noPasswordMismatch: (testPassword) => ({
    error: 'The passwords you entered do not match',
    validate: (password) => password === testPassword,
  }),
  noSequentialNumbers: (maxLength) => ({
    error: `Sequential numbers greater than ${maxLength} not allowed`,
    validate: (value) => !value || !(new RegExp(`\\d{${maxLength + 1},}`).test(value)),
  }),
};

export const getFieldErrorMessage = (formRules, key, value) => (
  formRules[key].reduce((message, rule) => {
    if (!rule.validate(value)) {
      return message ? `${message} | ${rule.error}` : rule.error;
    }

    return message;
  }, '')
);

export const validateField = (formRules, formErrors, setFormErrors, key, value) => {
  const fieldError = formRules[key] && getFieldErrorMessage(formRules, key, value);

  setFormErrors({ ...formErrors, [key]: fieldError });

  return Object.values(formErrors).reduce((hasNoErrors, error) => (hasNoErrors && !error), true);
};

export const validateForm = (formRules, formValues, formErrors, setFormErrors) => {
  const fieldErrors = Object.entries(formValues).reduce(
    (errors, [key, value]) => ({ ...errors, [key]: formRules[key] && getFieldErrorMessage(formRules, key, value) }),
    {},
  );

  setFormErrors(fieldErrors);

  return Object.values(fieldErrors).reduce((hasNoErrors, error) => (hasNoErrors && !error), true);
};

export const {
  isRequired,
  noSpecialCharacters,
  validEmail,
  hasNumbers,
  hasSpecialCharacters,
  hasUppercaseLetters,
  minLength,
  maxLength,
  noPasswordMismatch,
  noSequentialNumbers,
} = rules;

export const passwordValidationRules = [
  isRequired,
  hasNumbers,
  hasSpecialCharacters,
  hasUppercaseLetters,
  minLength(8),
];

export default rules;
